import { AppointmentDto } from "@apiModels/AppointmentDto.csharp";
import { AppointmentsAvailabilityDto } from "@apiModels/AppointmentsAvailabilityDto.csharp";
import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { FormStateType } from "./formTypes";
import {
  findRelatedServiceLocationSetup,
  isRelatedServiceEnabled,
} from "./relatedServiceHelper";

export function filterAppointments<
  T extends AppointmentDto | AppointmentsAvailabilityDto
>(
  state: FormStateType,
  appointments: T[] | undefined,
  filteredDoctors: DoctorDto[]
) {
  if (appointments === undefined) {
    return [];
  }

  let filtered = [...appointments];

  const skipFilteringForRelatedAppointment = (
    appointment: AppointmentDto | AppointmentsAvailabilityDto
  ) => {
    const relatedServiceSetup = state.relatedServiceSetups.find(
      (s) => s.relatedServiceId === appointment.relatedServiceId
    );
    const relatedServiceLocationSetup = findRelatedServiceLocationSetup(
      relatedServiceSetup,
      state.location
    );

    const applyLocationAndDoctorFilter =
      relatedServiceLocationSetup?.applyLocationAndDoctorFilter ??
      relatedServiceSetup?.applyLocationAndDoctorFilter;

    return !applyLocationAndDoctorFilter && appointment.isRelatedAppointment;
  };

  for (const rss of state.relatedServiceSetups) {
    if (
      !isRelatedServiceEnabled(rss, state.location) ||
      !state.showRelatedServicesMap.get(rss.relatedServiceId)
    ) {
      filtered = filtered.filter(
        (a) => a.relatedServiceId !== rss.relatedServiceId
      );
    }

    if (
      isRelatedServiceEnabled(rss, state.location) &&
      (findRelatedServiceLocationSetup(rss, state.location) ?? rss)
        .applyLocationAndDoctorFilter
    ) {
      filtered = filtered.filter(
        (a) =>
          a.relatedServiceId !== rss.relatedServiceId ||
          filteredDoctors.some((d) => d.id === a.doctorId)
      );
    }
  }
  
  if (!state.showBaseService) {
    filtered = filtered.filter((a) => a.isRelatedAppointment);
  }

  if (state.doctor.id && state.doctor.id != "-1") {
    filtered = filtered.filter(
      (a) =>
        a.doctorId == state.doctor.id || skipFilteringForRelatedAppointment(a)
    );
  }

  if (state.location.id && state.location.id != "-1") {
    const centers = state.location.isLocation
      ? state.location.centers
      : [state.location.id];
    filtered = filtered.filter(
      (a) =>
        centers.includes(a.centerId) || skipFilteringForRelatedAppointment(a)
    );
  }
  return filtered;
}
